import { Component, Inject, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
// import { EditNameComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'atw-text-paragraph-admin',
  templateUrl: './text-paragraph-admin.component.html',
  styleUrls: ['./text-paragraph-admin.component.scss'],
})

export class AtwTextParagraphAdmin implements OnInit {

  public EDITOR;

  dataContent: FormGroup;
  dataLoaded: boolean = false; // Biến cờ để kiểm tra xem dữ liệu đã được tải hay chưa

  /** ID của subproject đang làm việc */
  id_subproject: any;
  /** Index của tab được chọn */
  selectedIndex: number = 0;
  /** Thiết bị được chọn để cấu hình */
  device: string = 'desktop';
  /** Nội dung trước đó của editor */
  lastContent: any = {};

  devices = ['desktop', 'tablet_landscape', 'tablet_portrait', 'mobile_landscape', 'mobile_portrait'];
  data: any; // dữ liệu của object từ block truyền vào gồm {_id, component, desktop_position, mobile_portrait_position, x, y, rows, cols, z_index}
  doneLoad = false;

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    public functionService: FunctionService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AtwTextParagraphAdmin>,
    @Inject(MAT_DIALOG_DATA) public props: any,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      import('@ckeditor/ckeditor5-build-decoupled-document')
        .then(module => {
          this.EDITOR = module.default;
        })
        .catch(err => {
          console.error('CKEditor load error:', err);
        });
    }
    this.data = this.props.data
    // Lấy thiết bị hiện tại
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.device = JSON.parse(localStorage.getItem(this.id_subproject)) || 'desktop';
    this.selectedIndex = this.devices.indexOf(this.device);

    this.initForm();
    this.loadData();
  }


  public onReady(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.plugins.get('FileRepository').createUploadAdapter = (
      loader: any
    ) => {
      return this.vhImage.MyUploadImageAdapter(loader, 'images/design/objects')
    };
  }


  initForm() {
    this.dataContent = new FormGroup({
      // content: new FormControl(''),
    })
    
    let fieldNames:any = [
      {field: 'content', validators: {required: false, pattern: ''} },
    ];

    if (this.data?.staticdata?.is_different_content_for_devices) {
      this.devices.forEach((item) => {
        fieldNames.push({field: `${item}_content`, validators: {required: false, pattern: ''} });
      })
    }

    this.functionService.multi_languages.forEach((language: any) => {
      this.functionService.adminEditHandleChangeMultiLanguage(
        this.dataContent,
        language.code,
        [],
        fieldNames,
        this.data.staticdata,
        null,
      );
    });
    this.doneLoad = true;
  }

  getFormControl(controlName: string): FormControl {
    return this.dataContent.get(controlName) as FormControl;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes', changes);
    if (changes.data && !changes.data.firstChange) {
      this.loadData();
    }
  }


  loadData(): void {
    if (this.dataLoaded) return; // Nếu dữ liệu đã được tải, không gọi API nữa
    // this.setDataContentValue();
    this.dataLoaded = true; // Đánh dấu dữ liệu đã được tải
  }


  /**
   * Set trường content theo ngôn ngữ, dựa trên this.data?.staticdata và ngôn ngữ được chọn trong functionService.selectedLanguageCode, nếu không có thì lấy fallback từ multiLanguageFallback trong functionService
   */
  // setDataContentValue(language_code?: any) {
  //   const languageCode = language_code || this.functionService.languageTempCode;

  //   const contentField = (this.data?.staticdata?.is_different_content_for_devices && this.data?.staticdata[`${this.device}_content_${languageCode}`])
  //     ? `${this.device}_content_${languageCode}`
  //     : `content_${languageCode}` || this.functionService.multiLanguageFallback[this.data.component]['content'];
  //   const content = this.data?.staticdata[contentField];
  //   this.dataContent.setValue({ [contentField]: content });

  //   this.lastContent = this.getFormControl(contentField).value;
  // }

  updateFieldContentLangs(fieldUpdate) {
    this.functionService.multi_languages.forEach((lang) => {
      const handleContent = (device?: string) => {
        const prefix = device ? `${device}_content_` : `content_`;
        const contentField = `${prefix}${lang.code}`;
        fieldUpdate[contentField] = this.getFormControl(contentField).value;
      };
  
      if (this.data?.staticdata?.is_different_content_for_devices) {
        this.devices.forEach((device) => handleContent(device));
      } else {
        handleContent();
      }
    });
  }

  /**
   * Cập nhật dữ liệu staticdata của object
   */
  async updateStaticData() {
    this.updateFieldContentLangs(this.data.staticdata);

    if (this.functionService.getTypeConfig() == 'admin') {
      if (!this.data.hasOwnProperty('fieldUpdate')) this.data['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.data._id)) this.functionService.objectsAndBlocksUpdated.push(this.data)
      if (!this.data['fieldUpdate'].includes('staticdata')) this.data['fieldUpdate'].push('staticdata')
      this.vhEventMediator.notifyOnConfigChanged({ code: this.data._id, status: 'config-changed', id_parent: this.data.id_block || this.data.id_object });

      this.functionService.multi_languages.forEach((lang) => {
        const contentField = this.data?.staticdata?.is_different_content_for_devices
          ? `${this.device}_content_${lang.code}` 
          : `content_${lang.code}`;
        const updatedContent = this.getFormControl(contentField).value;
        this.lastContent[contentField] = updatedContent;
      })
      this.close()
      return;
    }

    this.vhQueryAutoWeb
      .updateObject(this.data._id, { staticdata: this.data.staticdata })
      .then((bool) => {
        this.functionService.createMessage('success', 'cap_nhat_du_lieu_thanh_cong');
        this.functionService.multi_languages.forEach((lang) => {
          const contentField = this.data?.staticdata?.is_different_content_for_devices
            ? `${this.device}_content_${lang.code}` 
            : `content_${lang.code}`;
          const updatedContent = this.getFormControl(contentField).value;
          this.lastContent[contentField] = updatedContent;
        })
        this.close()
      },
        (error) => {
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
          console.error(error);
        }
      );
  }


  /**
   * update dữ liệu của object
   * @param value - giá trị cần update
   */
  updateObject(value: any) {
    this.vhQueryAutoWeb
      .updateObject(this.data._id, value)
      .then(
        (bool) => {

        },
        (error) => {
          console.log(error);
        }
      );
  }





  /**
   * Khi thay đổi tab Thiết bị được chọn.
   * Nếu có thay đổi mà chưa lưu thì lưu luôn
   * @param event 
   */
  changeTabs(event: any) {
    // Nếu nội dung thay đổi thì cập nhật dữ liệu
    // if (JSON.stringify(this.dataContent.value) !== JSON.stringify(this.lastContent)) {
    //   this.updateStaticData();
    // }
    // else {
    //   this.lastContent = this.dataContent.value;
    // }

    if (event.index >= 0 && event.index < this.devices.length) {
      this.device = this.devices[event.index];
      // set lại nội dung cho editor
      // this.setDataContentValue();
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
